
import { ApiHttpService } from '../ApiHttpService';
import { CreditSerializer } from '../serializers/CreditSerializer';
import { PaymentSerializer } from '../serializers/PaymentSerializer';
import { Credit } from '../../models/Credit';
import { Payment } from '../../models/Payment';

const ADDRESS_PATH = 'usuario/CreditCustomer';

class CreditController {
  static async all(topCreds = 50, topPagos = 20) {
    const authenticated = true;
    const response = await ApiHttpService.get(ADDRESS_PATH, { topCreds, topPagos }, authenticated);
    const deSerializedCreditData = (response.data.Creditos || []).map(CreditSerializer.deSerialize);
    const deSerializedPaymentData = (response.data.Pagos || []).map(PaymentSerializer.deSerialize);
    return {
      credits: deSerializedCreditData.map(data => new Credit(data)),
      payments: deSerializedPaymentData.map(data => new Payment(data)),
    };
  }
}

export { CreditController };



// WEBPACK FOOTER //
// ./src/networking/controllers/CreditController.js